import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {ProductsProvider} from "./ProductsContext";
import {BuyersProvider} from "./BuyersContext";
// import {createTheme, MuiThemeProvider} from "@material-ui/core";
// import {koKR} from "@material-ui/core/locale";
import {koKR} from "@mui/material/locale";
import {UserProvider} from "./UserContext";
import {SnackbarProvider} from "notistack";
import {WarehouseProvider} from "./WarehouseContext";
import {createTheme, ThemeProvider} from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: '#2c387e'},
    secondary: {main: '#ff1744'},
    neutral: {
      main: '#484848',
      contrastText: '#fff',
    },
  },
}, koKR);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <BrowserRouter>
          <WarehouseProvider>
            <UserProvider>
              <BuyersProvider>
                <ProductsProvider>
                  <App />
                </ProductsProvider>
              </BuyersProvider>
            </UserProvider>
          </WarehouseProvider>
        </BrowserRouter>
      </SnackbarProvider>
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
